export function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this,
            args = arguments;

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
}
